import { getImg } from '@/utils/matchAsset'

export const matchSignupEntryData = {
  watchTitleImage: getImg('match/pc/match/signup-watch-title.png'),
  mobileHeroImage: getImg('match/pc/match/signup-mobile-page-bg.png'),
  mobileWatchTitleImage: getImg('match/pc/match/signup-mobile-watch-title.png'),
  cards: [
    getImg('match/pc/match/12.png'),
    getImg('match/pc/match/signup-info-card-featured.png'),
    getImg('match/pc/match/12.png'),
  ],
  mobileCards: [
    getImg('match/pc/match/12.png'),
    getImg('match/pc/match/signup-mobile-watch-card-2.png'),
    getImg('match/pc/match/12.png'),
  ],
  entryButtons: [
    {
      id: 'match-detail',
      image: getImg('match/pc/match/signup-entry-option-left.png'),
      hoverImage: getImg('match/pc/match/signup-entry-option-right-active.png'),
      mobileImage: getImg('match/pc/match/signup-mobile-entry-button-left.png'),
      link: '/match/detail',
    },
    {
      id: 'match-signup',
      image: getImg('match/pc/match/signup-entry-option-right.png'),
      hoverImage: getImg('match/pc/match/signup-entry-option-left-active.png'),
      mobileImage: getImg('match/pc/match/signup-mobile-entry-button-right.png'),
      route: '/',
      anchor: 'business-box',
    },
  ],
}

export const matchSignupFlowData = {
  titleImage: getImg('match/pc/match/signup-flow-title.png'),
  boardImage: getImg('match/pc/match/signup-flow-board.png'),
  characterImage: getImg('match/pc/match/signup-flow-character.png'),
  mobileTitleImage: getImg('match/pc/match/signup-mobile-flow-title.png'),
  mobileBoardImage: getImg('match/pc/match/signup-mobile-flow-board.png'),
  mobileCharacterImage: getImg('match/pc/match/signup-mobile-flow-character.png'),
  steps: [
    {
      title: '报名比赛',
      lines: [
        '报名时间：8月20日-9月10日',
        '参赛队伍随机匹配对手时间：9月12日',
        '参赛对战表公布时间：9月12日',
        '参赛队伍团练时间：9月1日-9月10日',
      ],
    },
    {
      title: '海选赛——晋级赛',
      lines: ['海选赛时间：9月15日起每日晚19点开始', '晋级赛时间：10月8日20点到10月15日20点每日一场'],
    },
    {
      title: '后续赛程总览',
      lines: ['四强半决赛：10 月 27 日（周二），两场同步开赛','季军争夺战 & 冠亚军总决赛：10 月 30 日（周五），两场同步开赛'],
    },
  ],
}

export const matchSignupInfoData = {
  titleImage: getImg('match/pc/match/signup-news-title.png'),
  boardImage: getImg('match/pc/match/signup-news-board.png'),
  mobileTitleImage: getImg('match/pc/match/signup-mobile-info-title.png'),
  mobileCoverImage: getImg('match/pc/match/5.png'),
  coverImages: [
    getImg('match/pc/match/5.png'),
    getImg('match/pc/match/4.png'),
  ],
  items: [
    {
      title: '赛事介绍',
      content: '首届千年线上争霸赛由千年IP官方江阴千游独家赞助举办，致力于推动千年IP文化传承和生态繁荣，采用公开奖金池、积分对抗、分级晋级模式，全程官方监督录像，账号、物资统一配发，保障赛事公平公正。',
    },
    {
      title: '赛事奖励',
      content: '作为中国大陆地区独家 IP 授权方我们期望通过携手本次赛事活动，进一步推动千年 IP 文化内涵，触达更多目标受众，实现文化与活动双向赋能，故为本次活动千年争霸赛事提供不低于20万RMB的现金奖励+实物周边奖励。',
    },
  ],
}
